import PlaceholderTopNav from './PlaceholderTopNav.client'

export default PlaceholderTopNav
